import React from 'react';
import { WrapperField } from '../../../../components/InputField/WrapperField';

const DEFAULT_FIELD_CLASS_NAME = 'col-12';
const normalizeTestIdSegment = (value = '') => String(value)
    .replace(/\[\]/g, '-item')
    .replace(/[^a-zA-Z0-9_-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

const BusinessV2FieldGrid = ({
    fieldOrder = [],
    fieldMap = {},
    data,
    asLabel,
    handleChange,
    hasError,
    onFieldError,
    defaultFieldClassName = DEFAULT_FIELD_CLASS_NAME,
    rowClassName = 'row gx-4 business-v2-field-grid',
    dataTestId = 'business-v2-field-grid',
}) => {
    const orderedFields = Array.isArray(fieldOrder) ? fieldOrder : [];

    if (!orderedFields.length) {
        return null;
    }

    return (
        <div className={rowClassName} data-testid={dataTestId}>
            {orderedFields.map((field) => {
                const jsonField = fieldMap?.[field];
                if (!jsonField?.uiType) {
                    return null;
                }

                const fieldClassName = `${jsonField?.uiClassName || defaultFieldClassName} business-v2-field-grid__item`;

                return (
                    <div
                        key={field}
                        className={fieldClassName}
                        data-testid={`${dataTestId}-${normalizeTestIdSegment(field)}`}
                    >
                        <WrapperField
                            disabled={asLabel}
                            jsonField={jsonField}
                            dataObj={data}
                            onChange={handleChange}
                            showError={hasError}
                            onError={(errorMsg) => onFieldError?.(field, errorMsg)}
                            className=""
                        />
                    </div>
                );
            })}
        </div>
    );
};

export default BusinessV2FieldGrid;
